export interface RosterSlot {
  id: string
  /** Fill these in when a signing goes live — the card layout stays identical. */
  name?: string
  niche?: string
  platform?: string
  followers?: string
  image?: string
}

/**
 * Placeholder roster. Add name/niche/platform/followers/image to a slot and the
 * card renders as a real profile with no layout changes required.
 */
export const rosterSlots: RosterSlot[] = [
  { id: 'slot-01' },
  { id: 'slot-02' },
  { id: 'slot-03' },
  { id: 'slot-04' },
]
